module.exports = __webpack_public_path__ + "static/media/logo-itaperuna.71c7c406.png";